import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<div class={style.header}>
		<div class="logoC">
		<Link activeClassName={style.active} href="/">		
		<img src="https://dl.dropbox.com/s/y2cai56y6h1xfmz/ALX_LOGO%20V2.png?dl=0"/>
		</Link>
		</div>
		<div class="socials">
      <a target="_blank" href="http://twitter.com/alxsoon"> <img src="/assets/twitter.svg" /></a>
      <a target="_blank" href="http://Instagram.com/soonalx"><img src="/assets/instagram.svg" /></a>
    </div>
		
	<nav>

			<Link activeClassName={style.active} href="/">music</Link>
			<Link activeClassName={style.active} href="/shop">shop</Link>
			<Link activeClassName={style.active} href="/videos">videos</Link>
			<Link activeClassName={style.active} href="/terms">terms</Link>
		
			
			
		</nav>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js